import {withNamespaces, WithNamespaces} from 'react-i18next'
import {isMobile} from '../../../../commons/selectors/environment'
import {downloadTicketsAction} from '../../../actions/tickets'
import {downloadTicketsForEvent} from '../../../services/tickets'
import {DetailedEvent, MemberPageContext} from '../../../types/state'
import {connect} from '../../connect'
import {DownloadTicketsButton as DownloadTicketsButtonPresentation} from './download-tickets-button'

export interface DownloadTicketsButtonProps
  extends DownloadTicketsButtonOwnProps,
    DownloadTicketsButtonRuntimeProps,
    WithNamespaces {}

interface DownloadTicketsButtonOwnProps {
  event: DetailedEvent
}

interface DownloadTicketsButtonRuntimeProps {
  mobile: boolean
  downloadTicketsForEvent: typeof downloadTicketsForEvent
  downloadTicketsAction: typeof downloadTicketsAction
}

const mapRuntime = ({state, actions}: MemberPageContext) => ({
  mobile: isMobile(state),
  downloadTicketsForEvent,
  downloadTicketsAction: actions.downloadTicketsAction,
})

export const DownloadTicketsButton = connect<DownloadTicketsButtonOwnProps, DownloadTicketsButtonRuntimeProps>(
  mapRuntime,
)(withNamespaces()(DownloadTicketsButtonPresentation))
